import React from 'react';
import { Container } from 'react-bootstrap';
import '../App.css';

function Footer() {
  return (
    <footer style={{
      padding: '50px 0',
      background: 'var(--bg-secondary)',
      borderTop: '1px solid var(--glass-border)',
      marginTop: '50px'
    }}>
      <Container className="text-center">
        <div style={{ marginBottom: '20px' }}>
          <a href="https://github.com/kevindevs" target="_blank" rel="noreferrer" style={{
            fontSize: '1.5rem',
            margin: '0 15px',
            color: 'var(--text-secondary)'
          }}>
            <i className="fa-brands fa-github"></i>
          </a>
          <a href="https://linkedin.com" target="_blank" rel="noreferrer" style={{
            fontSize: '1.5rem',
            margin: '0 15px',
            color: 'var(--text-secondary)'
          }}>
            <i className="fa-brands fa-linkedin"></i>
          </a>
        </div>
        <p style={{ color: 'var(--text-muted)', fontSize: '0.9rem' }}>
          &copy; {new Date().getFullYear()} Kevin Qu. All Rights Reserved.
        </p>
      </Container>
    </footer>
  );
}

export default Footer;
